import { SIZE_50 } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';
import { BubbleMapChart } from '@/components/composite/Charts/BubbleMapChart';

export const citiesDistributionConfig = {
    height: 300,
    name: {
        city: 'chart.facebook.cities_distribution_city',
        value: 'chart.facebook.cities_distribution_value',
        lat: 'chart.facebook.cities_distribution_lat',
        lng: 'chart.facebook.cities_distribution_lng',
        percentage: 'percentage'
    },
    defaultTableSorting: [{ id: 'value', desc: true }],
    deprecated: { status: '03/14/2024' },
    social: FACEBOOK,
    tooltip: 'chart.facebook.cities_distribution_tooltip',
    noLegend: true,
    datePickerDoesNotApply: true,
    id: 'cities_distribution',
    size: SIZE_50,
    type: 'chart',
    element: BubbleMapChart,
    defaultFilter: 'global',
    filters: {
        global: {
            title: 'chart.facebook.cities_distribution_fans',
            menu: 'chart.facebook.cities_distribution_filter_fans'
        },
        reach: {
            title: 'chart.facebook.cities_distribution_reach',
            menu: 'chart.facebook.cities_distribution_filter_reach'
        },
        engagement: {
            title: 'chart.facebook.cities_distribution_engagement',
            menu: 'chart.facebook.cities_distribution_filter_engagement'
        }
    }
};
